// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b27ec6d","239":"715a359e","455":"98b01f8c"}[chunkId] + ".chunk.js";
};